import sliceCreator from '../../index.jsx';
import {CREATE_FARMER} from '../../../constants/index.jsx';
const _createFarmerAction = sliceCreator('CREATE_FARMER', CREATE_FARMER, 'post');

const { asyncAction: createFarmerAction, reducer, clearData: clearCreateFarmerAction } = _createFarmerAction;

export default reducer;

export {
    createFarmerAction,
    clearCreateFarmerAction
}